import $ from 'jquery';
import Flickity from 'flickity';
import jQueryBridget from 'jquery-bridget';
import scrollToInvalid from '../modules/scrollToInvalid.js';
import ClipboardJS from 'clipboard';
import ajaxFilter from '../modules/ajaxFilter.js';
import ajaxForm from '../modules/ajaxForm.js';
import 'flickity-imagesloaded'

// Projects Carousel
Flickity.setJQuery($);

// TODO Check if we need this in `home.js` as well, and if
// not, maybe make it a utility we run in `app.js` instead.

/** @see https://github.com/metafizzy/flickity/issues/534#issuecomment-328859144 */
Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call( this );
  this.element.classList.add('flickity-resize');
};

jQueryBridget('flickity', Flickity, $);

const PartnersRoute = () => {
  //
  //   Scroll to Invalid Field
  //
  //////////////////////////////////////////////////////////////////////

  const form = document.querySelector('.js-form form');
  if (form) {
    scrollToInvalid(form, 0, 0, true);
  }

  //
  //   Copy to Clipboard
  //
  //////////////////////////////////////////////////////////////////////
  const $pageAlert = $('.js-page-alert');

  const copyCode = new ClipboardJS('.js-clipboard-btn');
  copyCode.on('success', function(e) {
    window.getSelection().removeAllRanges();
    $pageAlert.addClass('is-visible');
    setTimeout( function(){ 
        $pageAlert.removeClass('is-visible');
      }  , 2000 );
  });


  //
  //   Modal
  //
  //////////////////////////////////////////////////////////////////////
  const $modalToggle = $('.js-modal-toggle');
  const $modal = $('.js-modal');
  const isVisibleClass = 'is-visible';

  $modalToggle.on('click', function() {
    $modal.toggleClass(isVisibleClass);
  });


  //
  //   Partner Filtering
  //
  //////////////////////////////////////////////////////////////////////
  ajaxFilter();

  //
  //   Ajax Form
  //
  //////////////////////////////////////////////////////////////////////
  ajaxForm({
    form: '#js-hire-partner-form',
    errorMsg: '.js-hire-form-errors',
    successMsg: '.js-hire-form-success'
  });

  // Partners Carousel
  const $carousel = $('.js-carousel');
  const carouselSlide = '.js-carousel-slide';

  // init Flickity
  $carousel.flickity({
    cellSelector: carouselSlide,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: true,
    draggable: true,
    selectedAttraction: 0.08,
    friction: 0.5,
    imagesLoaded: true,
    cellAlign: 'center',
    contain: true,
  });

};

export default PartnersRoute;
